let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("jVK6j")).then(() => parcelRequire('hduFx'));